import {FormikProps} from 'formik';
import React from 'react';
import MyTextField from 'shared/components/MyTextField';
import {SencropWeatherStationCredentials} from '../models/BaseWeatherStationSchema';
interface SencropProviderProps {
  formikProps: FormikProps<SencropWeatherStationCredentials>;
  disable: boolean;
}

const SencropCredentialsForm: React.FC<SencropProviderProps> = ({
  formikProps,
  disable,
}) => {
  const {email} = formikProps.values;

  return (
    <>
      <MyTextField
        variant='outlined'
        fullWidth
        name='email'
        label='Email'
        type='email'
        value={email}
        disabled={disable}
      />
    </>
  );
};

export default SencropCredentialsForm;
